import {createRoot} from 'react-dom/client';
import React from 'react';

const root = createRoot(document.getElementById('app-mount'));

root.render(<h1>Test</h1>);
